module.exports = __webpack_public_path__ + "static/media/img_0.95eaaab1.png";